import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useQuery as l, useQueryClient as u } from "@tanstack/react-query";
//#region src/Client.ts
var d = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7077/Pools";
	}
	getPoolSafetyCertificate(e, t, n, r, i) {
		let a = this.baseUrl + "/GetPoolSafetyCertificate?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		if (a += "state=" + encodeURIComponent("" + t) + "&", n == null) throw new globalThis.Error("The parameter 'lotNumber' must be defined and cannot be null.");
		if (a += "lotNumber=" + encodeURIComponent("" + n) + "&", r == null) throw new globalThis.Error("The parameter 'planNumber' must be defined and cannot be null.");
		a += "planNumber=" + encodeURIComponent("" + r) + "&", a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (h(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetPoolSafetyCertificate(e)));
	}
	processGetPoolSafetyCertificate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return m("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return m("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return m("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, f = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e;
}({}), p = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isPoolsApiException = !0;
	static isPoolsApiException(e) {
		return e.isPoolsApiException === !0;
	}
};
function m(e, t, n, r, i) {
	throw i ?? new p(e, t, n, r, null);
}
function h(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var g = "pools";
function _(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var v = (e, t, n) => {
	let r = new d(e);
	return r.setAuthConfig(t, n), _(r);
}, y = ({ baseApiUri: e, devMode: t, localUris: n }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	let r = n?.[g];
	return t && r ? r : `${e}/${g}`;
}, b = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = y(i), u = c, d = v(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(v(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, x = a({}), S = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = b(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(x.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, C = (e, t, n, i, a) => {
	let s = r(19), c = a === void 0 ? !0 : a, u = o(x), d;
	s[0] !== e || s[1] !== n || s[2] !== i || s[3] !== t ? (d = [
		"getPoolSafetyCertificate",
		e,
		t,
		n,
		i
	], s[0] = e, s[1] = n, s[2] = i, s[3] = t, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== u || s[6] !== e || s[7] !== n || s[8] !== i || s[9] !== t ? (p = (r) => {
		let { signal: a } = r;
		return u.getPoolSafetyCertificate(e, t, n, i, a);
	}, s[5] = u, s[6] = e, s[7] = n, s[8] = i, s[9] = t, s[10] = p) : p = s[10];
	let m = c && !!u, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v } = l(h), y;
	return s[15] !== g || s[16] !== v || s[17] !== _ ? (y = {
		data: g,
		isPending: _,
		isError: v
	}, s[15] = g, s[16] = v, s[17] = _, s[18] = y) : y = s[18], y;
}, w = () => {
	let e = r(2), t = u(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i) => {
		await t.invalidateQueries({ queryKey: [
			"getPoolSafetyCertificate",
			e,
			n,
			r,
			i
		] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { x as PoolsApiContext, p as PoolsApiException, S as PoolsApiProvider, d as PoolsClient, g as PoolsRoute, f as UploadedDocumentDocumentType, C as useGetPoolSafetyCertificate, w as useInvalidateUseGetPoolSafetyCertificate, b as usePoolsClientContext };
